import { api } from '@api/api2';
import type { TicketTypesPayload } from './types';

export const getTicketTypes = (payload: TicketTypesPayload) =>
  api.v4('get', 'ticket/types/list', payload);
